import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			config: {
				fields: {
					author: {},
					subject: {},
					message: {
						config: {
							visible: false
						}
					},
					created_at: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		edit: {
			panel: {
				width: '70%'
			},
			config: {
				fields: {
					author: {},
					subject: {},
					message: {},
					files: {
						fields: {
							name: {},
							storever: {},
							size: {},
							description: {},
							author: {},
							created_at: {}
						}
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}